import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import { querySysCategoryTreeList } from '@/api/api';
import IwsUpload from '@comp/upload/IwsUpload';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  mixins: [JeecgListMixin],
  components: {
    IwsUpload: IwsUpload
  },
  name: 'DocModal',
  data: function data() {
    return {
      form: this.$form.createForm(this),
      docId: '',
      hiding: true,
      spinning: false,
      disableSubmit: false,
      categoryTree: [],
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入标题!'
          }]
        },
        keyword: {
          rules: [{
            required: true,
            message: '请输入关键字!'
          }]
        }
      },
      url: {
        add: '/sys/doc/add',
        edit: '/sys/doc/edit'
      },
      selectedKeysDoc: 1,
      root: 0
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.categoryTree = [];
      var ss = this.$route.path.split("/");
      this.root = ss[ss.length - 1];
      var param = {
        pid: this.root
      };
      querySysCategoryTreeList(param).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.categoryTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    add: function add(record) {
      this.hiding = false;
      this.remarkCommet = '';
      this.edit(record);
    },
    edit: function edit(record) {
      var _this2 = this;

      console.log(record);
      this.loadTree();
      this.hiding = false;
      this.remarkCommet = '';
      this.fileDelList = [];
      this.docId = record.id;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this2.form.setFieldsValue(pick(_this2.model, 'category', 'title', 'keyword', 'sort', 'remark', 'createBy_userName', 'createTime', 'updateBy_userName', 'updateTime')); //时间格式化


        _this2.form.setFieldsValue({
          createTime: _this2.model.createTime ? moment(_this2.model.createTime) : null
        });

        _this2.form.setFieldsValue({
          updateTime: _this2.model.updateTime ? moment(_this2.model.updateTime) : null
        });
      });
    },
    close: function close() {
      this.model.id = "";
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this3.model.id) {
            httpurl += _this3.url.add;
            method = 'post';
          } else {
            httpurl += _this3.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this3.model, values); //时间格式化

          formData.createTime = formData.createTime ? formData.createTime.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.updateTime = formData.updateTime ? formData.updateTime.format('YYYY-MM-DD HH:mm:ss') : null;
          debugger;
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData);
          console.log(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};